import { ErrorSuspendStorePage } from '@services/MarppleShop/renderApp/pages/ErrorSuspendStore/ErrorSuspendStorePage.ts';

export const errorSuspendStoreRouter = {
  '@errorSuspendStore': ErrorSuspendStorePage,
};
